import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconAiPaste = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...omit(props, ["className"])}
    className="yfm-icon yfm-icon-ai-paste"
  >
    <path
      d="M10.308 0C11.2424 0 12 0.7576 12 1.692V7.8456C12 8.78 11.2432 9.5376 10.3088 9.5384H9.5384V10.3952C9.5384 11.2456 8.8768 11.9416 8.04 11.9968L7.9344 12H2.3072C1.0816 12 0.0704 11.0424 0.0032 9.8184L0 9.692V4.0656C0 3.216 0.6616 2.5192 1.4984 2.4656L1.604 2.4616H2.4608V1.692C2.4616 0.7576 3.2192 0 4.1536 0H10.3072H10.308ZM2.4616 3.384H1.6048C1.2536 3.384 0.9648 3.6504 0.9272 3.992L0.9232 4.0656V9.692C0.9232 10.424 1.4896 11.0224 2.2088 11.0736L2.308 11.0768H7.9344C8.2848 11.0768 8.5744 10.8112 8.6112 10.4704L8.6152 10.396V9.5384H4.1536C3.2192 9.5384 2.4616 8.7816 2.4608 7.8472V3.3848L2.4616 3.384ZM10.308 0.9232H4.1536C3.7288 0.9232 3.384 1.2672 3.384 1.692V7.8456C3.384 8.2704 3.7288 8.6152 4.1536 8.6152H10.3072C10.7328 8.6152 11.0768 8.2704 11.0768 7.8456V1.6936C11.0768 1.268 10.7328 0.924 10.308 0.924V0.9232ZM5.692 5.5384H8.7696C9.024 5.5376 9.232 5.7432 9.2328 5.9976C9.2336 6.2296 9.0624 6.4264 8.832 6.4568L8.7696 6.4608H5.692C5.4376 6.4608 5.2304 6.256 5.2296 6.0008C5.2296 5.7688 5.4008 5.5728 5.6304 5.5424L5.692 5.5384ZM8.7696 3.0768C9.0248 3.0768 9.2312 3.2832 9.2312 3.5384C9.2312 3.7936 9.0248 4 8.7696 4H5.692C5.4368 4 5.2304 3.7936 5.2304 3.5384C5.2304 3.2832 5.4368 3.0768 5.692 3.0768H8.7696Z"
      fill="#17215C"
    />
  </svg>
));

IconAiPaste.displayName = "IconAiPaste";

export default IconAiPaste;
